<template>
  <v-card class="elevation-0">
    <v-card-title tabindex="-1">
      <span class="headline">Add Raw Materials</span>
    </v-card-title>
    <v-card-text>
      <v-form v-on:submit.prevent width="100%" ref="createForm">
        <v-select
            v-model="createFields.raw_materials_id"
            :rules="validationRules.raw_materials_id"
            :items="rawMaterials"
            item-text="name"
            item-value="id"
            label="Raw Material"
            name="raw_materials_id"
            :error-messages="inputErrorMessages('raw_materials_id')"
            v-on:keyup.enter="saveJobOrderMaterial"
            @change="changeUnitType()"
          ></v-select>
        <v-text-field
          v-model="createFields.quantity"
          label="Quantity/Weight"
          :rules="validationRules.quantity"
          name="quantity"
          :error-messages="inputErrorMessages('quantity')"
          v-on:keyup.enter="saveJobOrderMaterial"
        />
        <v-text-field
          :disabled="true"
          v-model="createFields.unit_type"
          label="Unit Type"
          name="unit_type"
        />
      </v-form>
      <small>* indicates required field</small>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="saveJobOrderMaterial">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';

export default {
  data: function() {
    return {
      validationRules: {
        raw_materials_id: [v => !!v || this.rem('Raw Material')],
        quantity: [
          v => !!v || this.rem('Quantity'),
          v => (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999999999) || 'Invalid Quantity',
          v => v > 0 || 'Quantity should be greater than 0'
        ]
      },
      errorMessages: {},
      createFields: {
        quantity: 1,
        raw_materials_id: undefined,
        unit_type: ''
      }
    };
  },
  computed: {
  ...mapState({
      rawMaterials: state => state.RawMaterial.plainrawMaterials
    })
  },
  mounted() {
    this['RawMaterial/fetchRawMaterials']({ dontPaginate: false });
  },
  props: {
    create: false,
    page: 0
  },
  methods: {
    ...mapActions([
      'RawMaterial/fetchRawMaterials',
      'JobOrder/fetchJobOrders',
      'JobOrder/getJobOrder'
    ]),
    clearCreate() {
      this.createFields = {
        quantity: 1,
        raw_materials_id: undefined,
        unit_type: ''
      };
      this.$refs.createForm.resetValidation();
    },
    rem(name) {
      return `${name} is required`;
    },
    inputErrorMessages(input) {
      return this.errorMessages[input];
    },
    saveJobOrderMaterial() {
      if (this.$refs.createForm.validate()) {
        this.loading = true;
        axios
          .post(`api/v1/joborder/${this.$route.params.id}/addrawmaterial`, this.createFields)
          .then(response => {
            this.$store.commit('SET_SNACK_BAR', {
              message: 'Raw Material added successfully...',
              color: 'success'
            });
            this.errorMessages = [];
            this.$refs.createForm.resetValidation();
            this.clearCreate();
            this['JobOrder/getJobOrder']({ id: this.$route.params.id });
            this.$emit('added');
          })
          .catch(response => {
            this.errorMessages = response.response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    changeUnitType(){
      axios
        .post(`api/v1/joborder/getunittype`, this.createFields)
        .then(response => {
          this.createFields.unit_type = response.data;
        })
        .catch(response => {
          this.errorMessages = response.response.data.errors;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>